module.exports = __webpack_public_path__ + "img/service_devops_2.7ba59d1e.jpg";